module.exports = __webpack_public_path__ + "static/media/cosentino-global-icon-c.b3830a2e.svg";